import { global } from "../../constants";

export const data = {
  banner: {
    base: "政策",
    background: global.banner + "maritime-law.webp",
    title: "隐私政策",
    crumb: "隐私政策",
  },
  title: "隐私政策",
  description: "作为个人数据的控制者，ASEMARINSA在此告知其网站用户，本公司遵守欧盟通用数据保护条例（GDPR）、巴拿马2019年第81号法以及适用于委内瑞拉的宪法原则。以下内容详细说明了所收集的数据类别、处理目的、法律依据、保存期限、第三方转移、用户权利、已采取的安全措施以及行使这些权利的联系方式。",
  politics: [{
    index: 1,
    title: "收集的个人数据",
    content: "通过网站的联系表单，要求用户提供其自行填写的个人数据：姓名、电子邮件地址、电话号码和所发送的信息。此类数据可使ASEMARINSA处理咨询、信息请求并提供其物流、海事咨询、保险及航务手续服务。同时，也会收集用户在表单中自愿提供的其他任何资料。"
  }, {
    index: 2,
    title: "处理目的",
    content: "所收集的数据仅用于回应用户提交的咨询和信息请求，并在用户明确同意时用于向其通报已承接的服务或新的优惠信息。数据处理对于管理ASEMARINSA与数据主体之间的商业及合同关系是必要的。因此，处理目的为合法且明确，例如处理请求、提供报价及与所请求服务相关的商业通信。"
  },{
    index: 3,
    title: "法律依据",
    content: "处理您数据的法律依据为用户在提交表单时给出的明确同意，以及在适用情况下为履行与ASEMARINSA关系中的前合同措施之必要性。在适当情形下，控制者依法可基于合法利益进行处理（例如改进服务质量或处理索赔），前提是该等利益不优先于数据主体的权利与自由。无论如何，若处理基于同意，用户有权随时撤回同意，而不影响撤回前基于同意进行的处理的合法性。"
  },{
    index: 4,
    title: "数据保存",
    content: "所提供的个人数据将在实现收集目的所需的期限内保存，并在存在相互利益（例如处理请求或申请）期间保留。一般情况下，关系结束或适用的法律保存期届满后，数据可被删除。保存标准将考虑各国适用的法律（例如税务或法律归档义务）。在任何情况下，ASEMARINSA将遵循数据最小化原则，仅在必要的最短期限内保存信息。"
  },{
    index: 5,
    title: "向第三方披露数据",
    content: "除法律义务或为实现上述目的所必需的情况外（例如为回应咨询而聘用的服务提供商），ASEMARINSA不会将用户的个人数据披露或转让给第三方。如进行此类披露，ASEMARINSA将要求这些第三方提供足够的保障以遵守数据保护法规。如发生任何国际数据传输（例如在境外使用云服务），将按照GDPR和巴拿马法律的授权进行，确保适当的合同条款或合规性决定。"
  },{
    index: 6,
    title: "用户权利",
    content: "用户可随时行使其在GDPR及各国法律中规定的权利，包括访问、更正、删除、反对（ARCO权利）以及限制处理、可移植性和被遗忘权。具体而言，数据主体有权请求访问其数据、更正不准确信息、在适用时删除数据、限制或反对数据处理，并以结构化格式获取数据以便转移至其他控制者。若处理基于同意，数据主体可随时撤回同意。若用户认为其权利未获妥善处理，有权向主管监管机构提出投诉。为行使上述任何权利，数据主体可将书面请求（并附身份证件复印件）发送至电子邮箱 asemarinsa@asemarinsa.com 或邮寄至ASEMARINSA注册地址（Av. Balboa, Torre Bac, piso 13, oficina 2, Ciudad de Panamá, Panamá）。ASEMARINSA将按照法律规定的期限处理请求。"
  },{
    index: 7,
    title: "数据安全",
    content: "ASEMARINSA采取必要的技术和组织措施以确保个人数据的机密性、完整性和可用性，遵守GDPR第32条的要求。除其他措施外，网站采用SSL加密、限制授权人员访问信息，并定期执行备份。此类措施旨在保护数据免受未授权访问、丢失或销毁。"
  },{
    index: 8,
    title: "适用法律",
    content: "个人数据的处理受GDPR（法规(EU) 2016/679）、西班牙有机法3/2018及其实施法规，以及巴拿马2019年第81号法的约束。在委内瑞拉，尽管不存在专门的个人数据法，ASEMARINSA仍尊重宪法所确立的隐私与私密原则及最高法院宪法庭的指引，确保在国际最佳实践范围内实施知情同意与信息保护。"
  },{
    index: 9,
    title: "联系方式",
    content: "如有关于本政策的任何疑问或欲行使数据保护权利，用户可书面联系 ASEMARINSA，电邮至 asemarinsa@asemarinsa.com 或寄往上述注册地址。同样提醒用户，可向主管机关提出投诉：在西班牙向西班牙数据保护局（AEPD），在巴拿马向国家透明与信息获取机构（ANTAI）。"
  }]
};